import React from 'react';
import PropTypes from 'prop-types';
import IconLabel from 'components/common/IconLabel';
import PreMatriculadoCard from './PreMatriculadoCard';

const AlunoPreMatriculadoCard = ({ usuario }) => {
  const { student, curriculum, practical_field, conta } = usuario;

  return (
    <PreMatriculadoCard
      usuario={usuario}
      photo_url={student?.photo}
      person_id={student?.person}
      student_curriculum_id={usuario?.id}
      conta_id={conta}
    >
      <h3 className="font-weight-600">{student.name}</h3>
      <div className="d-flex justify-space-between">
        <div>
          <IconLabel
            icon="graduation-cap"
            label={curriculum.course_name || ''}
          />
          <IconLabel icon="book" label={curriculum.name || ''} />
        </div>
      </div>
    </PreMatriculadoCard>
  );
};

AlunoPreMatriculadoCard.propTypes = {
  usuario: PropTypes.shape({
    curriculum: PropTypes.shape({
      name: PropTypes.string,
      course: PropTypes.shape({
        nome: PropTypes.string,
      }),
    }),
    student: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    id: PropTypes.number,
  }).isRequired,
};

export default AlunoPreMatriculadoCard;
